
export default {
  productData: {
    serialNumber: 'DA-HMUF-006',
    name: 'Holzbalkendecken mit Unterdecken an Federschienen | Aufbau 6',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Zementgebundene Spanplatte ZSP oder Gipsfaserplatte GF' },
          output: '≥ 22',
          value: 'd-22'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 30 MN/m<sup>3</sup>; AnwendungsgebietDES-sg)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 45 kg/m<sup>2</sup>), ggf. Rieselschutz' },
          output: '≥ 30',
          value: 'scsb-30'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Federschiene' },
          output: '27',
          value: 'f-27'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '353,5', value: 353.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '45 (1)',
        value: 45
      },
      soundReductionIndex: { // Rw
        output: '67 (-4; -10)',
        value: 67
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,29',
        value: 0.29
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '124,8 [kg/m²]'
      }
    }
  },
  image: 'da-hmuf-006.png',
  pdf: 'Holzbalkendecken-mit-Unterdecken-an-Federschiene-Aufbau-6-DA-HMUF-006-Rev03.pdf'
}
